const state = {
    participation_agreement: []
}
const getters = {
    PARTICIPATIONAGREEMENT: state => {
        return state.participation_agreement;
    },
}
const mutations = {
    SET_PARTICIPATIONAGREEMENT: (state, value) => {
        state.participation_agreement = value;
    },
    ADD_PARTICIPATIONAGREEMENT: (state, value) => {
        // re-init array
        state.participation_agreement = [];

        state.participation_agreement.push(value);
    }
}
const actions = {
    SAVE_PARTICIPATIONAGREEMENT: async (context, value) => {
        // save participation agreement info

        context.commit("ADD_PARTICIPATIONAGREEMENT", value);
    }
}

export default {
    state, getters, mutations, actions
}